import { MultiFieldDynamicFields } from '../multiFieldDynamicFields';
import { FormikProps } from 'formik';
import { MultiDynamicField } from '../../../../../shared/types/assistant';

export const CommunicationArchitecture = ({
    formikCommunicationArchitecture,
}: {
    formikCommunicationArchitecture: FormikProps<{
        [key: string]: MultiDynamicField[];
    }>;
}) => {
    return (
        <MultiFieldDynamicFields
            formik={formikCommunicationArchitecture}
            name="communicationArchitecture"
            label="Arquitectura de Comunicación"
            description="Configura los modos de interacción de tu asistente para ofrecer respuestas adaptadas a cada tipo de consulta, garantizando una comunicación eficiente y centrada en la experiencia del usuario. Incluyendo Modo Rápido, Modo Explicativo y Modo Escalamiento."
            example={{
                title: 'Modo Rápido',
                description:
                    'Para consultas directas, respuesta en formato de chat.',
            }}
        />
    );
};
